<template>
  <div class="flex items-center justify-between p-2">
    <dropdown class="mt-1" placement="bottom-end">
      <template #default>
        <div class="group flex items-center cursor-pointer select-none" title="Download Documents">
          <div v-if="label" class="border px-4 py-3 -mt-1 flex items-center justify-between">
            <span>Download Documents</span>
            <icon class="w-4 h-4 fill-gray-700 group-hover:fill-blue-600 focus:fill-blue-600" name="cheveron-down" />
          </div>
          <icon v-else class="w-4 h-4 fill-gray-700 group-hover:fill-blue-600 focus:fill-blue-600" name="download" />
        </div>
      </template>
      <template #dropdown>
        <div class="mt-2 py-2 text-sm bg-white  shadow-xl">
          <a class="block px-6 py-2 hover:text-white hover:bg-blue-500" :href="`/runs/${ runId }/drawing`" target="_blank">Drawings</a>
          <a class="block px-6 py-2 hover:text-white hover:bg-blue-500" :href="`/runs/${ runId }/bom`" target="_blank">BOM PDF</a>
        </div>
      </template>
    </dropdown>
  </div>
</template>

<script>

import Icon from '@/Shared/Icon'
import Dropdown from '@/Shared/Dropdown'

export default {
  components: {
    Dropdown,
    Icon,
  },
  props: {
    runId: Number,
    label: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
